// extracted by mini-css-extract-plugin
module.exports = {"window":"Window_window__2ECt9","content":"Window_content__IwQIp"};